import React, { useState } from "react";
import { Boxes } from "../ui_components/uiExporter";
import _ from 'underscore';
// import "./checkInPeriods.scss";
import useCheckinPeriods from "../hooks/useCheckinPeriods";
import ProgressIndicator from "../../../components/ProgressIndicator";

import t from '../../../helpers/t';
import { Biscuit } from '../../../../utils';

const uuid = _.uniqueId;

const CheckInPeriods = () => {

  const [dropdown,setDropdown] = useState({});
  
  const {
    childCount,
    result,
    setCurrentSelected,
    active,
    selected,
    setSelected
  } = useCheckinPeriods();

  // check in periods will be placed in boxes from filtered store that is using ALL filter by default
  return (
    <div
        id="boxes"
        className="periods">
        <div
          id="scrollParent"
          className={`periods-holder ${childCount > 3 ? 'periods-holder--many' : ''}`}
          style={{ opacity: result.messagesReducer === "LOADING" ? 0.3 : 1 }}
        >
        {result.filterPeriodsReducer.length > 0 ? (
          result.filterPeriodsReducer.map((period, i) => (
            <div className={`focused ${i === active ? 'focused--shadow' : ''}`} key={uuid()}>
              <Boxes
                key={uuid()}
                childCount={childCount}
                active={i === active}
                selected={selected[i]}
                setSelected={setSelected}
                id={uuid()}
                data={period}
                dropdown={dropdown}
                setDropdown={setDropdown}
                setCurrentSelected={setCurrentSelected}
                style={{
                  opacity: result.messagesReducer === "LOADING" ? "1" : "0.4",
                  marginRight: "30px"
                }}
              />
            </div>
          ))
        ) : (
          <div style={{ textAlign: "center", width: "100%", marginTop: "20px" }}>
              {result.messagesReducer !== "CITY" && 
               result.messagesReducer !== "LOADING" &&
               <div
                  id="inb-app-collection-empty"
                  className="inb-announcement">
                      <div className="inb-image-box">
                        <img src="assets/img/no_data.svg" />
                      </div>
                      <h3>{t('no_location_pick_one')}</h3>
                  </div>
              }
              {result.messagesReducer === "CITY" &&
               result.periods.length === 0 && 
                  <p>
                      {t('no_periods_add_one')}
                  </p>
              }
            {result.messagesReducer === "PRICE" &&
                result.periods.length === 0 &&
                <p>
                  {t('no_periods_add_one')}
                </p>
            }
              {Biscuit.get('client.isBikeSharing') === 'true' && 
                  <p style={{color:'red'}}>
                      {t('is_bikesharing_no_opening_times')}
                  </p>
              }
          </div>
        )}
      </div>
      {result.messagesReducer === "LOADING" && (
        <ProgressIndicator
          style={{
            position: "fixed",
            top: "30%",
            left: "50%",
            zIndex: 999999,
            opacity: "1 !important"
          }}
        />
      )}
    </div>
  );
};
export default CheckInPeriods;
